import React, { useRef, useEffect } from "react";
import "./contactform.css";
import image from "../../Assets/Images/ContactUs/contact-us.png";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const ContactForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // const formRef = useRef();
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData(formRef.current);
  //   const name = formData.get("name")?.trim();
  //   const email = formData.get("email")?.trim();
  //   const subject = formData.get("subject");
  //   const message = formData.get("message");
  //   const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   if (!name) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Name Required",
  //       text: "Please enter your name.",
  //       confirmButtonColor: "#f7931a",
  //         cancelButtonColor: "#1C1C1C",
  //     });
  //     return;
  //   }

  //   if (!email) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Email Required",
  //       text: "Please enter your email address.",
  //       confirmButtonColor: "#f7931a",
  //         cancelButtonColor: "#1C1C1C",
  //     });
  //     return;
  //   }

  //   if (!emailPattern.test(email)) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Invalid Email",
  //       text: "Please enter a valid email address.",
  //       confirmButtonColor: "#f7931a",
  //         cancelButtonColor: "#1C1C1C",
  //     });
  //     return;
  //   }

  //   const data = {
  //     name,
  //     email,
  //     subject,
  //     message
  //   };

  //   Swal.fire({
  //     title: "Sending...",
  //     text: "Please wait while we process your request",
  //     allowOutsideClick: false,
  //     showConfirmButton: false,
  //     didOpen: () => Swal.showLoading()
  //   });

  //   try {
  //     await fetch(
  //       "https://services.leadconnectorhq.com/hooks/CL8kBGrERKWFyIMGQBcF/webhook-trigger/4032faeb-d0e4-47c2-9655-b8662ad2a4a9",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json"
  //         },
  //         body: JSON.stringify(data)
  //       }
  //     );

  //     // ✅ SUCCESS
  //     Swal.fire({
  //       icon: "success",
  //       title: "Sent!",
  //       text: "Your message was sent successfully.",
  //       confirmButtonColor: "#f7931a",
  //         cancelButtonColor: "#1C1C1C",
  //     });

  //     formRef.current.reset();

  //   } catch (error) {
  //     console.error(error);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Something went wrong. Please try again later.",
  //       confirmButtonColor: "#f7931a",
  //         cancelButtonColor: "#1C1C1C",
  //     });
  //   }
  // };

  return (
    <div className="contactform-ss-block-ui brightness">
      <div className="ssb-img">
        <img src={image} alt="Contact Form" />
      </div>

      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">Contact Us</h2>
        </div>

        <div className="ssb-desc">
          <iframe
            src="https://api.leadconnectorhq.com/widget/form/jEHKA8QS0yoMHqtxUIPq"
            style={{
              // width: "700px",
              height: "715px",
              border: "none",
              borderRadius: "3px",
              filter: "brightness(0.86)"
            }}
            id="inline-jEHKA8QS0yoMHqtxUIPq"
            data-layout="INLINE"
            data-trigger-type="alwaysShow"
            data-activation-type="alwaysActivated"
            data-deactivation-type="neverDeactivate"
            data-form-name="Opt-In Form"
            data-form-id="jEHKA8QS0yoMHqtxUIPq"
            title="Opt-In Form"
          />

          {/* <form ref={formRef} onSubmit={handleSubmit}>

            <input type="text" name="name" placeholder="Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <input type="text" name="subject" placeholder="Subject" required />
            <textarea name="message" placeholder="Comments & Requests" required />

            <button type="submit">Submit</button>

          </form> */}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
